import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './marketing/theme.css';
import { App } from './App.tsx';
import { initWebVitals } from './web-vitals.js';

const root = document.getElementById('root');
if (root) {
  createRoot(root).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

initWebVitals();
